import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import LoginForm from '../components/LoginForm';
import { login } from '../services/auth';
import api from '../services/api'; // CORREÇÃO AQUI: Importar como default

// NOVO: Componente ForgotPasswordModal
const ForgotPasswordModal = ({ onClose, onSendEmail }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isSending, setIsSending] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSending(true);
        setMessage('');
        setError('');
        try {
            await onSendEmail(email);
            setMessage('Se o e-mail estiver registrado, um link de redefinição será enviado.');
            setEmail(''); // Limpa o campo
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao solicitar redefinição de senha.');
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className="modal-overlay" style={modalOverlayStyle}>
            <div className="modal-content" style={forgotModalContentStyle}>
                <h2 style={modalTitleStyle}>Esqueci a Senha</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group" style={formGroupStyle}>
                        <label style={labelStyle}>E-mail:</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={inputStyle}
                            disabled={isSending}
                        />
                    </div>
                    {message && <p style={successMessageStyle}>{message}</p>}
                    {error && <p style={errorMessageStyle}>{error}</p>}
                    <div style={buttonGroupStyle}>
                        <button type="button" onClick={onClose} style={cancelButtonStyle} disabled={isSending}>
                            Cancelar
                        </button>
                        <button type="submit" style={saveButtonStyle} disabled={isSending}>
                            {isSending ? 'Enviando...' : 'Enviar Link'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const Login = () => {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const recaptchaRef = useRef(null);
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false); // NOVO: Estado para o modal

    const handleLogin = async (email, password, token) => {
        try {
            await login(email, password, token);
            navigate('/');
        } catch (err) {
            setError('Email ou senha inválidos');
            recaptchaRef.current.reset();
        }
    };

    // NOVO: Função para enviar e-mail de redefinição
    const handleSendResetEmail = async (email) => {
        await api.post('/password/forgot', { email }); // Chama o endpoint da sua API
    };

    return (
        <div className="login-page" style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #3498db 0%, #2ecc71 100%)'
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '40px',
                borderRadius: '8px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                width: '100%',
                maxWidth: '400px'
            }}>
                <h1 style={{
                    textAlign: 'center',
                    marginBottom: '30px',
                    color: '#2c3e50'
                }}>Meu Caixa</h1>
                {error && <p style={{ color: 'red', textAlign: 'center', marginBottom: '15px' }}>{error}</p>}
                <LoginForm onLogin={handleLogin} recaptchaRef={recaptchaRef} />

                {/* NOVO: Link "Esqueci a senha?" */}
                <p style={{ textAlign: 'center', marginTop: '15px' }}>
                    <a href="#" onClick={() => setShowForgotPasswordModal(true)} style={{ color: '#3498db', textDecoration: 'none' }}>
                        Esqueci a senha?
                    </a>
                </p>

                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6LfeSCwrAAAAAKpKBiqycIN6zVzcoINT4eUE4xsj" // Sua sitekey do reCAPTCHA
                    size="invisible"
                />
            </div>
            {/* NOVO: Modal de Esqueci a Senha */}
            {showForgotPasswordModal && (
                <ForgotPasswordModal
                    onClose={() => setShowForgotPasswordModal(false)}
                    onSendEmail={handleSendResetEmail}
                />
            )}
        </div>
    );
};

// --- ESTILOS PARA OS MODAIS (REDEFINIR E ESQUECI SENHA) ---
const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
};

const forgotModalContentStyle = {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '8px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    textAlign: 'center'
};

const modalTitleStyle = {
    fontSize: '1.5rem',
    marginBottom: '20px',
    color: '#2c3e50'
};

const formGroupStyle = {
    marginBottom: '15px',
    textAlign: 'left'
};

const labelStyle = {
    display: 'block',
    marginBottom: '5px',
    fontWeight: '600',
    color: '#555',
    fontSize: '0.9rem',
};

const inputStyle = {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem',
    boxSizing: 'border-box',
};

const buttonGroupStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '20px',
};

const baseButtonStyle = {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '1rem',
    transition: 'background-color 0.2s ease'
};

const cancelButtonStyle = {
    ...baseButtonStyle,
    backgroundColor: '#95a5a6',
    color: 'white',
};

const saveButtonStyle = {
    ...baseButtonStyle,
    backgroundColor: '#3498db',
    color: 'white',
};

const successMessageStyle = {
    color: '#28a745',
    backgroundColor: '#d4edda',
    padding: '10px',
    borderRadius: '4px',
    marginBottom: '15px',
    fontSize: '0.9rem',
    textAlign: 'center'
};

const errorMessageStyle = {
    color: '#dc3545',
    backgroundColor: '#f8d7da',
    padding: '10px',
    borderRadius: '4px',
    marginBottom: '15px',
    fontSize: '0.9rem',
    textAlign: 'center'
};

export default Login;